module.exports = __webpack_public_path__ + "2-53db0698.worker.js"